module.exports = __webpack_public_path__ + "static/media/publicCert.4f616261.jpg";